import React from "react";
import loadingGif from "../../assets/image/loading.gif";

export default function Loading() {
  return (
    <div
      className="w-full flex items-center justify-center"
      style={{ width: "100%" }}
    >
      <img
        style={{ width: "100%", maxWidth: "50px" }}
        src={loadingGif}
        alt="loading"
      />
    </div>
  );
}
